import React from "react";
import { useParams } from "react-router-dom";
import "../../assets/scss/components/_packageoverview.scss";
import packages from "../../data/OurPackagesSection/packagesSection.json";

const PackageOverview = () => {
  const { slug } = useParams();

  const packageData = packages.find((item) => item.slug === slug);

  if (!packageData) return <p>Package not found</p>;

  return (
    <section className="package-overview">
      <div className="package-overview__container">
        {/* LEFT */}
        <div className="package-overview__left">
          <img
            src={require(`../../assets/img${packageData.bigImage}`)}
            alt={packageData.title}
            className="main-image"
          />
        </div>

        {/* RIGHT */}
        <div className="package-overview__right">
          <h2>{packageData.title}</h2>
          <p>{packageData.overview}</p>
          <button className="enquire-btn">Enquire Now</button>
        </div>
      </div>
    </section>
  );
};

export default PackageOverview;

// import React, { useState } from "react";
// import "../../assets/scss/components/_packageoverview.scss";

// const PackageOverview = ({ title, overview, gallery = [] }) => {
//   const [activeIndex, setActiveIndex] = useState(0);

//   const prevImage = () => {
//     setActiveIndex((prev) => (prev === 0 ? gallery.length - 1 : prev - 1));
//   };

//   const nextImage = () => {
//     setActiveIndex((prev) => (prev === gallery.length - 1 ? 0 : prev + 1));
//   };

//   return (
//     <section className="package-overview">
//       <div className="package-overview__container">

//         <div className="package-overview__left">

//           <img src={gallery[activeIndex]} alt={title} className="main-image" />

//           <div className="controls-row">
//             <div className="arrows">
//               <button onClick={prevImage}>&#10094;</button>
//               <button className="active" onClick={nextImage}>
//                 &#10095;
//               </button>
//             </div>

//             <div className="thumbs">
//               {gallery.map((img, index) => (
//                 <img
//                   key={index}
//                   src={img}
//                   alt="thumb"
//                   className={index === activeIndex ? "active" : ""}
//                   onClick={() => setActiveIndex(index)}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="package-overview__right">
//           <h2>{title}</h2>
//           <p>{overview}</p>
//           <button className="enquire-btn">Enquire Now</button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PackageOverview;
